import * as React from "react";
import { SlideSearch24Regular, SlideSearch24Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const WhereIsMyFixApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "WhereIsMyFix" */ "./WhereIsMyFixApp");
    return { default: namedExport.WhereIsMyFixApp };
});

export const WhereIsMyFix: TeamAppConfig = {
    title: "Where Is My Fix?",
    regularIcon: SlideSearch24Regular,
    filledIcon: SlideSearch24Filled,
    description:
        "Track where your code changes are in the deployment pipeline — query by alias, PR, or build version" +
        " to see saturation progress across rings and regions.",
    team: "DeploymentCore",
    publicId: "Exchange\\Deployment(Multi-Tenant)",
    owner: "o365deploycore@microsoft.com",
    role: "*",
    tags: ["Build Freshness", "Where Is My Fix", "Deployment", "Saturation"],
    app: WhereIsMyFixApp,
    path: "/WhereIsMyFix"
};
